import "../App.css";
import SurveyStatusPage from "../components/question-components/survey-status";

const OverQuota = () => {
  return <SurveyStatusPage status="over_quota" />;
};

export default OverQuota;
